import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "grid gap-3 sm:grid-cols-1" }

import { Combobox, InputRow, SectionHeader } from '@/components/ui/form';
    import type { OutlayCompany } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyOutlayForm',
  props: {
    form: {},
    outlayCompanies: {},
    isPendingOutlayCompanies: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const outlayCompanyOptions = computed(() => {
        return props.outlayCompanies.map((item: OutlayCompany) => {
            const isSelected = item.keepers !== null && item.keepers.id === props.form.id;

            const name =
                item.outlay.vat !== ''
                    ? `${item.outlay.id}: ${item.outlay.name} - ${item.outlay.vat}`
                    : `${item.outlay.id}: ${item.outlay.name}`;

            return {
                value: item.outlay.id,
                label: name,
                addon: !isSelected && item.keepers !== null ? `(${item.keepers.name})` : '',
            };
        });
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.outlay_tab_text')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "outlay_company_id",
        label: "companies.form.outlay_company_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Combobox), {
            modelValue: _ctx.form.outlay_company_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.outlay_company_id) = $event)),
            options: outlayCompanyOptions.value,
            placeholder: _ctx.$t('companies.outlay.deselect'),
            loading: _ctx.isPendingOutlayCompanies
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _: 1
      }, 8, ["form"])
    ])
  ]))
}
}

})